import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addHomeGroupStaffFailure,
  //
  addHomeGroupStaffSuccess,
  deleteHomeGroupStaffFailure,
  //
  deleteHomeGroupStaffSuccess,
  editHomeGroupStaffFailure,
  //
  editHomeGroupStaffSuccess,
  fetchHomeGroupStaffs as fetchHomeGroupStaffsAction,
  fetchHomeGroupStaffsFailure,
  fetchHomeGroupStaffsSuccess,
  getViewDataFailure,
  getViewDataSuccess,
  setStaffFailure,
  //
  setStaffSuccess,
  inviteStaffSuccess,
  inviteStaffFailure,
} from "./actions";
import {
  ADD_HOME_GROUP_STAFF,
  DELETE_HOME_GROUP_STAFF,
  EDIT_HOME_GROUP_STAFF,
  FETCH_HOME_GROUP_STAFFS,
  GET_VIEW_DATA,
  OPEN_STAFF_EDIT_MODAL,
  INVITE_STAFF,
} from "./constants";

export function* fetchHomeGroupStaffsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin-user?${query}`
    );
    yield put(fetchHomeGroupStaffsSuccess(data));
  } catch (e) {
    yield put(fetchHomeGroupStaffsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care home group!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin-user/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}
export function* getEditDataSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin-user/${payload}`
    );
    yield put(setStaffSuccess(data));
  } catch (e) {
    yield put(setStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching staff!"));
  }
}

export function* addHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin-user/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Staff added successfully!"));
      yield put(addHomeGroupStaffSuccess());
      yield put(
        fetchHomeGroupStaffsAction({
          page: 1,
          limit: 10,
          company_id: payload.company_id,
        })
      );
    }
  } catch (e) {
    yield put(addHomeGroupStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin-user/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Staff updated successfully!"));
      yield put(editHomeGroupStaffSuccess());
      yield put(
        fetchHomeGroupStaffsAction({
          page: 1,
          limit: 10,
          company_id: payload.company_id,
        })
      );
    }
  } catch (e) {
    yield put(editHomeGroupStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteHomeSaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/company-admin-user/${payload}`
    );
    if (data) {
      yield put(successAlert("Staff deleted successfully!"));
      yield put(deleteHomeGroupStaffSuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteHomeGroupStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* inviteStaffSaga({ payload, onInvSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/invite-staff-mail`, payload);
    if (data) {
      yield put(successAlert("Invite sent successfully!"));
      yield put(inviteStaffSuccess());
      typeof onInvSuccess === "function" && onInvSuccess();
    }
  } catch (e) {
    yield put(inviteStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchHomeGroupStaffsFlow() {
  yield takeEvery(FETCH_HOME_GROUP_STAFFS, fetchHomeGroupStaffsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addHomeFlow() {
  yield takeEvery(ADD_HOME_GROUP_STAFF, addHomeSaga);
}
export function* editHomeFlow() {
  yield takeEvery(EDIT_HOME_GROUP_STAFF, editHomeSaga);
}
export function* deleteHomeFlow() {
  yield takeEvery(DELETE_HOME_GROUP_STAFF, deleteHomeSaga);
}
export function* getEditDataFlow() {
  yield takeEvery(OPEN_STAFF_EDIT_MODAL, getEditDataSaga);
}
export function* inviteStaffFlow() {
  yield takeEvery(INVITE_STAFF, inviteStaffSaga);
}
export default function* HomeGroupsStaffSaga() {
  yield all([
    fetchHomeGroupStaffsFlow(),
    addHomeFlow(),
    editHomeFlow(),
    deleteHomeFlow(),
    getViewDataFlow(),
    getEditDataFlow(),
    inviteStaffFlow(),
  ]);
}
